import { 
  CREATE_JOURNAL_VOUCHER, 
  GET_JOURNAL_VOUCHER, 
  GET_JOURNAL_VOUCHER_PAGE, 
  JOURNAL_VOUCHER_REQUEST,
  DELETE_JOURNAL_VOUCHER,
  UPDATE_JOURNAL_VOUCHER, 
  JOURNAL_VOUCHER_REQUEST_FAILURE, 
  JOURNAL_VOUCHER_REQUEST_SUCCESS 
} from "../types";

const initialState = {
    journalVouchers: [],
    journalVouchersPage: [],
    page: 1,
    pageSize: 10,
    search: '',
    showTaxJv: false,
    where: {},
    total: 0,
    loading: false,
    error: null,
  };

const journalVoucherReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOURNAL_VOUCHER_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_JOURNAL_VOUCHER: {
      return {
        ...state,
        journalVouchers: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_JOURNAL_VOUCHER_PAGE: {
        const { data, total, page, pageSize, search, showTaxJv, where } = action.payload || {};
        return {
          ...state,
          journalVouchersPage: [...data],
          total,
          page,
          pageSize,
          showTaxJv: showTaxJv || false,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
    }
    case CREATE_JOURNAL_VOUCHER: {
      return {
        ...state,
        journalVouchers: [action.payload, ...state.journalVouchers],
        loading: false,
        error: null
      };
    }
    case UPDATE_JOURNAL_VOUCHER: {
      const journalVouchersData = state.journalVouchers.slice(0);
      const uIndex = journalVouchersData.findIndex((data) => data.id === action.payload.id);
      journalVouchersData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        journalVouchers: [ ...journalVouchersData ],
        loading: false,
        error: null
      };
    }
    case DELETE_JOURNAL_VOUCHER: {
      const journalVouchers = state.journalVouchers?.slice(0);
      const index = journalVouchers.findIndex((data) => data.id === action.id);
      if (index > -1) {
          journalVouchers.splice(index, 1);
      }
      return {
        ...state,
        journalVouchers: [...journalVouchers],
        loading: false,
        error: null
      }
    }
    case JOURNAL_VOUCHER_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case JOURNAL_VOUCHER_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default journalVoucherReducer;
